import request from '@/utils/request';
import { validAlias } from '@/utils/validate';
import { useFd } from '@/utils/formData';
/**
 * AEW Client ApplicationForm API
 */
export function fetchApplicationForm(formId) {
  const data = useFd('AEW/Client/ApplicationFormDetail', {
    application_form_id: formId
  })
  return request({
    method: 'post',
    data
  })
}

export function updateApplicationForm(formId, fields, file) {
  const data = useFd('AEW/Client/ApplicationUpdate', {
    application_form_id: formId,
    fields: JSON.stringify(fields)
  })
  if (file) data.append('attach_file', file)
  return request({
    method: 'post',
    data
  })
}

export function fetchApplicationFormList({ page, formType = 'results', projectId = 1 }) {
  const data = useFd('AEW/Client/ApplicationFormList', {
    project_id: projectId,
    form_type: formType,
    page
  })
  return request({
    method: 'post',
    data
  })
}

export function ListApplicationForms(project, page) {
  return request({
    url: '/api/projects/' + validAlias(project) + '/applicationForms',
    method: 'get',
    params: page,
  });
}

export function GetApplicationForm(id) {
  return request({
    url: '/api/applicationForms/' + id,
    method: 'get',
  });
}

export function downloadFile(url) {
  return request({
    url: url,
    method: 'get',
    responseType: 'blob',
  });
}



// WEBPACK FOOTER //
// ./src/api/client/ApplicationForm.js